import { ArrayField } from 'react-hook-form';
import { Fragment } from 'react';

import { StyledFlex } from '@dreryk/react-components';

import {
   DosageStageUnion,
   DosageStageValidation,
   isDosageStageDuplicable,
   NO_DOSAGE_STAGE_VALIDATION,
} from '~libs.shared.prescription';

import { ExtendedDosageFormController } from '../ExtendedDosageForm.types';
import { DosageCycleClass } from '../../extendedDosage.utils';

import { StageField } from './StageField';
import { StyledStageSeparator } from './StageField.styled';
import { useStageFieldList } from './StageFieldList.hooks';

type StageFieldListProps = Pick<ExtendedDosageFormController, 'register' | 'watch' | 'setValue' | 'trigger'> & {
   readonly fields: Partial<ArrayField<DosageStageUnion>>[];
   readonly stageValidations: DosageStageValidation[];
   readonly portionUnit: string | null;
   readonly onRemove: (index: number) => void;
   readonly onDuplicate: (index: number) => void;
   readonly onChangeStageMode: (index: number, mode: DosageCycleClass) => void;
};

export const StageFieldList = (props: StageFieldListProps): JSX.Element => {
   const { ordinalNumbers, stageClasses, durationDays } = useStageFieldList({
      watch: props.watch,
      fields: props.fields,
   });

   return (
      <StyledFlex direction={'column'} gap={'16px'}>
         {props.fields.map((field, index) => (
            <Fragment key={field.id}>
               {index > 0 ? <StyledStageSeparator /> : null}
               <StageField
                  register={props.register}
                  watch={props.watch}
                  setValue={props.setValue}
                  trigger={props.trigger}
                  field={field}
                  index={index}
                  validation={props.stageValidations[index] ?? NO_DOSAGE_STAGE_VALIDATION}
                  ordinalNumber={ordinalNumbers[index]}
                  days={durationDays[index]}
                  duplicable={isDosageStageDuplicable(stageClasses, index)}
                  portionUnit={props.portionUnit}
                  onRemove={props.onRemove}
                  onDuplicate={props.onDuplicate}
                  onChangeStageMode={props.onChangeStageMode}
               />
            </Fragment>
         ))}
      </StyledFlex>
   );
};
